module["exports"] = [
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
];
